/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-15 08:18:35 */

const Keys = {
  night: 'night',
  week: 'week',
  nightComma: 'nightComma',
  nights: 'nights',
  weekComma: 'weekComma',
  weeks: 'weeks',
  from: 'from',
  to: 'to',
  chooseDuration: 'chooseDuration',
  chooseRangeLabel: 'chooseRangeLabel',
  durationPlaceholder: 'durationPlaceholder'
}; export default Keys;